<dialog
  qai-dialog
  #dialog
  [heading]="'simulationBuilder.SIMULATION_TYPE_MODAL_TITLE' | transloco"
  [description]="'simulationBuilder.SIMULATION_TYPE_MODAL_DESCRIPTION' | transloco"
  (afterClose)="handleAfterClose()"
  (cancel)="handleCancel($event)"
  (click)="handleBackdropClick($event)"
>
  <div class="type-option-grid">
    <simulation-type-option
      [icon]="'message-chat-square'"
      [title]="'simulationBuilder.SIMULATION_TYPE_ROLE_PLAY_TITLE' | transloco"
      [description]="'simulationBuilder.SIMULATION_TYPE_ROLE_PLAY_DESCRIPTION' | transloco"
      [bestFor]="'simulationBuilder.SIMULATION_TYPE_ROLE_PLAY_BEST_FOR' | transloco"
      (selected)="handleTypeSelect(SimulationTypeEnum.ROLE_PLAY)"
    ></simulation-type-option>

    <simulation-type-option
      [icon]="'file-check'"
      [title]="'simulationBuilder.SIMULATION_TYPE_KNOWLEDGE_CHECK_TITLE' | transloco"
      [description]="'simulationBuilder.SIMULATION_TYPE_KNOWLEDGE_CHECK_DESCRIPTION' | transloco"
      [bestFor]="'simulationBuilder.SIMULATION_TYPE_KNOWLEDGE_CHECK_BEST_FOR' | transloco"
      (selected)="handleTypeSelect(SimulationTypeEnum.KNOWLEDGE_CHECK)"
    ></simulation-type-option>
  </div>
</dialog>
